// extracted by mini-css-extract-plugin
module.exports = {"noticeHome":"styles_noticeHome__ApMMY","title":"styles_title__9UYlw","more":"styles_more__I7bkd","listNotices":"styles_listNotices__ndqFx","notice":"styles_notice__q_1qF"};